// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border {\n  border: 1px solid #e0e6eb !important;\n  border-radius: 0.25rem !important;\n  margin: 0 0 25px 0 !important;\n  padding: 5px 15px;\n}\nlabel {\n  font-size: 14px;\n  color: #818181;\n  text-align: left !important;\n  position: relative;\n  width: 100%;\n  margin: 0;\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
